export function downloadReport(report) {
  const esc = (s) => String(s || "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
  const body = esc(report.content).split(/\n\s*\n/).map((p) => `<p>${p.replace(/\n/g, "<br/>")}</p>`).join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(report.title)}</title>
<style>body{font-family:Arial,sans-serif;color:#071426;max-width:780px;margin:40px auto;padding:0 24px;line-height:1.6}
header{border-bottom:3px solid #D6B36A;padding-bottom:16px;margin-bottom:24px}h1{font-size:24px;margin:8px 0}
.meta{color:#475569;font-size:13px}.sum{background:#F1F5F9;padding:16px;border-radius:8px}
footer{margin-top:40px;font-size:11px;color:#64748b;border-top:1px solid #e2e8f0;padding-top:12px}</style></head>
<body><header><strong style="color:#00A872">QUANTORA</strong><h1>${esc(report.title)}</h1>
<div class="meta">Prepared for ${esc(report.client_name)} · ${new Date(report.created_at).toLocaleDateString("en-IN")} · ${esc(report.type.replace("_", " "))}</div></header>
<div class="sum">${esc(report.summary)}</div>${body}
<footer>Quantora Analytics Private Limited. This report is for educational and general guidance purposes only and is not investment advice. Projections are illustrative and not guaranteed. Investments are subject to market risks.</footer></body></html>`;
  const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${report.title.replace(/[^a-z0-9]+/gi, "-")}.html`;
  a.click();
  URL.revokeObjectURL(url);
}
